<template>
  <el-dialog
    :model-value="modelValue"
    title="选择实际出库库位"
    :width="compact ? '92%' : '480px'"
    align-center
    append-to-body
    :close-on-click-modal="false"
    @update:model-value="onVisible"
  >
    <p class="loc-hint">{{ hintText }}</p>
    <p v-if="payload?.planned_location_label" class="loc-planned">
      原计划库位：{{ payload.planned_location_label }}
    </p>
    <p class="loc-need">
      本次出库数量：{{ formatQty(payload?.required_quantity) }}
    </p>
    <el-select
      v-model="selectedId"
      filterable
      placeholder="请选择有货库位"
      style="width: 100%"
    >
      <el-option
        v-for="opt in options"
        :key="opt.storage_location_id"
        :label="optionLabel(opt)"
        :value="opt.storage_location_id"
        :disabled="opt.enough_for_required === false"
      />
    </el-select>
    <p v-if="!options.length" class="loc-empty">当前无可用库位，请先确认库存后再试。</p>
    <template #footer>
      <el-button @click="onVisible(false)">取消</el-button>
      <el-button type="primary" :disabled="!selectedId" @click="confirm">确认并出库</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  payload: { type: Object, default: null },
  compact: { type: Boolean, default: false }
})
const emit = defineEmits(['update:modelValue', 'confirm'])

const selectedId = ref(null)

const options = computed(() => {
  const list = Array.isArray(props.payload?.location_options) ? props.payload.location_options : []
  return list
})

const hintText = computed(
  () =>
    props.payload?.message ||
    '原计划库位已无足够库存（可能已移库），请选择实际出库库位，避免扣错库位。'
)

watch(
  () => props.modelValue,
  (v) => {
    if (!v) return
    const enough = options.value.filter((o) => o.enough_for_required !== false)
    const prefer =
      enough.find((o) => o.storage_location_id === props.payload?.planned_storage_location_id) ||
      enough[0] ||
      options.value[0]
    selectedId.value = prefer?.storage_location_id ?? null
  }
)

function formatQty (n) {
  const x = Number(n)
  if (!Number.isFinite(x)) return '—'
  return String(Number(x.toFixed(4)))
}

function optionLabel (opt) {
  const label = opt.location_label || opt.location_name || opt.location_code || `库位#${opt.storage_location_id}`
  const phys = formatQty(opt.physical_quantity)
  const flag = opt.enough_for_required === false ? '（不足）' : ''
  return `${label} · 物理 ${phys}${flag}`
}

function onVisible (v) {
  emit('update:modelValue', v)
}

function confirm () {
  if (!selectedId.value) return
  emit('confirm', Number(selectedId.value))
  onVisible(false)
}
</script>

<style scoped>
.loc-hint {
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.5;
  color: #303133;
}
.loc-planned,
.loc-need {
  margin: 0 0 8px;
  font-size: 13px;
  color: #606266;
}
.loc-empty {
  margin: 10px 0 0;
  font-size: 13px;
  color: #f56c6c;
}
</style>
